'use client';

import { Divider, styled } from '@mui/material';

interface DottedDividerProps {
  size?: number;
}

export const DottedDivider = styled( Divider )<DottedDividerProps>((
  { theme, size = 10, ...props }
) => ({
  width: '100%',
  height: size,
  border: 'none',
  backgroundImage: `radial-gradient(black ${size / 10}px, transparent 0)`,
  backgroundSize: `${size}px ${size}px`,
  backgroundPosition: 'bottom',
  backgroundRepeat: 'repeat-x',
  ...props,
}));
